import { FC } from "react";

export const ExplainerTitle: FC<{ title: string }> = ({ title }) => (
  <span className="text-base font-medium text-gray-800 whitespace-normal md:text-lg">
    {title}
  </span>
);
